import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShieldHalved,
  faCodeBranch,
  faLightbulb,
} from '@fortawesome/free-solid-svg-icons';
import Section from './Section';
import './Focus.css';

/* TODO(Adam): tune these to your actual wheelhouse */
const focusAreas = [
  {
    icon: faShieldHalved,
    title: 'Security & Trust',
    body: 'Threat-aware design, secure-by-default builds, and validation before it bites you.',
  },
  {
    icon: faCodeBranch,
    title: 'Fintech Engineering',
    body: 'Dependable services for money-movement, data at scale and analytics.',
  },
  {
    icon: faLightbulb,
    title: 'Pragmatic Delivery',
    body: 'Scoping what matters and shipping it, giving a solid base for the next iteration.',
  },
];

function Focus() {
  return (
    <Section name="focus" title="What I Focus On" tone="elevated">
      <ul className="focus__grid">
        {focusAreas.map(({ icon, title, body }) => (
          <li key={title} className="focus__card">
            <FontAwesomeIcon
              icon={icon}
              className="focus__icon"
              aria-hidden="true"
            />
            <h3 className="focus__card-title">{title}</h3>
            <p className="focus__card-body">{body}</p>
          </li>
        ))}
      </ul>
    </Section>
  );
}

export default Focus;
